/* eslint-disable */
import { apiURL } from 'config/baseURL';
import i18n from 'i18n';
import { toast } from 'helpers/toast';
import { getToken } from 'reducers/api';
import * as actions from 'reducers/lms/userManagement/userGroupList/userGroupList.action';
import * as types from 'reducers/lms/userManagement/userGroupList/userGroupList.actionTypes';
import { call, put, takeLatest } from 'redux-saga/effects';
import { RootState } from 'store/rootReducers';
import { select } from 'typed-redux-saga';
import { UsecaseReturn, PaginationResult, UserGroupResponse } from '@nimbly-technologies/nimbly-common';
import { UserGroupPopulatedResponse } from 'reducers/lms/userManagement/userGroupList/type';
import { gatewayFetch } from '../../../helpers/gateway';

// Map frontend sortBy fields to backend expected field names
const sortFieldMapping: Record<string, string> = {
	createdDate: 'createdAt',
	numberOfMembers: 'members',
	coursesEnrolled: 'courseIDs',
};

const mapSortField = (sortBy: string) => {
	return sortFieldMapping[sortBy] || sortBy;
};

function* getUserGroupList(action: ReturnType<typeof actions.getUserGroupList.request>) {
	try {
		// @ts-ignore
		const authToken = yield getToken();

		const userListState: any = yield* select((state: RootState) => state.lmsUserGroup);

		const options = {
			method: 'GET',
			headers: {
				Authorization: authToken,
			},
		};

		const query: { [key: string]: string | number } = {
			page: userListState.pageIndex || 1,
			limit: userListState.limit || 15,
			search: userListState.search || '',
			sortFields: mapSortField(userListState.sortBy),
			sortDirections: userListState.sortDirection,
		};

		const queryStr = Object.keys(query).length
			? Object.keys(query)
					.map((key: string) => {
						return query[key] && `${key}=${query[key]}`;
					})
					.join('&')
			: '';

		const getUserListURL = `${apiURL}/lms/user-groups?${queryStr}`;

		const request = () => gatewayFetch(getUserListURL, options);
		// @ts-ignore
		const response = yield call(request);

		if (response && response.status === 200) {
			const resData: UsecaseReturn<PaginationResult<UserGroupPopulatedResponse>> = yield response.json();
			yield put(actions.getUserGroupList.success(resData.data!));
		} else {
			// @ts-ignore
			const UserGroupResponseData = yield response.json();
			const message = UserGroupResponseData.message;
			toast.error(message, { containerId: 'toast-message-container' });
			yield put(actions.getUserGroupList.failure({ error: UserGroupResponseData.message }));
		}
	} catch (e) {
		toast.error(i18n.t('message.lms.userManagement.userGroup.fetch.failed'));
		yield put(actions.getUserGroupList.failure({ error: 'Failed to Fetch User Group List' }));
	}
}

function* selectAllUserGroups(action: ReturnType<typeof actions.selectAllUserGroups.request>) {
	try {
		// @ts-ignore
		const authToken = yield getToken();

		const userListState: any = yield* select((state: RootState) => state.lmsUserGroup);

		const options = {
			method: 'GET',
			headers: {
				Authorization: authToken,
			},
		};

		const query: { [key: string]: string | number } = {
			page: 1,
			limit: userListState.totalUserGroups || 1000,
			search: userListState.search || '',
			sortFields: mapSortField(userListState.sortBy),
			sortDirections: userListState.sortDirection,
		};

		const queryStr = Object.keys(query).length
			? Object.keys(query)
					.map((key: string) => {
						return query[key] && `${key}=${query[key]}`;
					})
					.join('&')
			: '';

		const getAllUserGroupsURL = `${apiURL}/lms/user-groups?${queryStr}`;

		const request = () => gatewayFetch(getAllUserGroupsURL, options);
		// @ts-ignore
		const response = yield call(request);

		if (response && response.status === 200) {
			const resData: UsecaseReturn<PaginationResult<UserGroupPopulatedResponse>> = yield response.json();
			yield put(actions.selectAllUserGroups.success(resData.data!.docs));
			yield put(actions.setGlobalSelectedUserGroups(resData.data!.docs));
		} else {
			// @ts-ignore
			const errorData = yield response.json();
			const message = errorData.message;
			toast.error(message, { containerId: 'toast-message-container' });
			yield put(actions.selectAllUserGroups.failure({ error: errorData.message }));
		}
	} catch (e) {
		toast.error(i18n.t('message.lms.userManagement.userGroup.selectAll.failed'));
		yield put(actions.selectAllUserGroups.failure({ error: 'Failed to Select All User Groups' }));
	}
}

export default function* userGroupListSaga() {
	yield takeLatest(types.GET_USER_GROUP_LIST_REQUEST, getUserGroupList);
	yield takeLatest(types.SET_USER_GROUP_LIST_PAGE_INDEX, getUserGroupList);
	yield takeLatest(types.SET_USER_GROUP_LIST_FILTER_QUERY, getUserGroupList);
	yield takeLatest(types.SET_USER_GROUP_LIST_SEARCH_QUERY, getUserGroupList);
	yield takeLatest(types.SET_USER_GROUP_LIST_SORT, getUserGroupList);
	yield takeLatest(types.SELECT_ALL_USER_GROUPS_REQUEST, selectAllUserGroups);
}
